import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router';
import { withSnackbar } from 'notistack';
import { Button, Grid, TextField, CircularProgress, Tooltip, Drawer } from '@material-ui/core';
import { LabelValueCard, RevisionHistory, PageLoader, DeletePopUp, CustomChip, CustomDropzone, PreviewDocsModal } from '../../../../shared_elements';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { assetId, backendDateFormat, displayDateFormatShort, fieldDateFormat } from '../../../../constants';
import { capitalizeFirstLetter, checkApiStatus, checkPermission, downloadFile, toastFlashMessage } from '../../../../utils_v2';
import { fieldValidation, dateRangeValidation } from '../../../../utils_v2/formValidation';
import { addEoaApi, getEoaApi } from '../apiServices';
import { addEoa, errorCode } from '..';
import { globalDeleteService, globalPostService } from '../../../../utils_v2/globalApiServices';
import { addAttachmentApi, deleteAttachmentApi } from '../../../../shared_elements/apiServices';
import { regexConstants } from '../../../../constants/regEx';
import moment from 'moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { avationPlcInstance, leshaBankInstance, mtInstance } from '../../../../shared_elements/components';

class ExceptionAcceptenceCRU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      formSubmitLoader: false,
      pageLoader: false,
      mode: '',
      eoa: {},
      error: {},
      previewDocs: '',
      deleteAttachmentModal: false,
      deleteItem: null,
      attachedDoc: [],
      showFullRemarks: false,
    }
    this.addEoaApi = addEoaApi.bind(this);
    this.getEoaApi = getEoaApi.bind(this);
  }
  onFieldChange = (event, keyParam, data) => {
    if (['eta_reference','eta_amount','eta_completion_date','eta_remarks','eta_significant','eta_date','eta_status','eta_component'].includes(keyParam)) {
      this.setState(prevState => ({
        eoa: {
          ...prevState.eoa,
          extra_fields: {
            ...prevState.eoa?.extra_fields,
            [keyParam]: data,
          },
        },
      }));
    } else {
      this.setState(prevState => ({
        ...prevState,
        eoa: {
          ...prevState.eoa,
          [keyParam]: data
        }
      }))
    }
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]: message
      }
    }))
  }
  toggleFnc = (key, status) => {
    this.setState({ [key]: status })
  }
  addAttachment = (data) => {
    const { props, params } = this.props;
    const { attachedDoc, eoa } = this.state;
    let formdata = new FormData();

    attachedDoc.forEach(item => {
      formdata.append('files', item);
    });

    formdata.append('asset_type', assetId[params?.type])
    formdata.append('asset_slug', params.aircraft_slug);
    formdata.append('contract_slug', params.contract_slug);
    formdata.append('model_type', '11');
    formdata.append('object_id', data?.data?.id)
    this.setState({ pageLoader: true });
    globalPostService(`contracts/attachments/`, formdata)
      .then(response => {
        if (response.data.statusCode === 200) {
          this.props.getResponseBack();
          toastFlashMessage(data?.message, 'success');
        } else {
          toastFlashMessage(response.data.message, 'error');
        }
        this.setState({ pageLoader: false });
      });
  }
  addEditEtaFn = () => {
    const { eoa } = this.state;
        let validationInputs = {
          name:errorCode['name'][fieldValidation({...errorCode['eoaObj'], fieldval: eoa?.name })],
          eta_completion_date:eoa.extra_fields.eta_completion_date ? moment(eoa.extra_fields.eta_completion_date).isValid() ?'':'Enter Valid Completion Date':'',
          eta_date:eoa.extra_fields.eta_date ? moment(eoa.extra_fields.eta_date).isValid() ?'':'Enter Valid Date':''
        };
    if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
      if (this.state.attachedDoc?.length + eoa?.attachments?.length > 50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return;
      }
      this.setState({ formSubmitLoader: true });
      this.addEoaApi(this.props, eoa)
        .then(response => {
          this.setState({ formSubmitLoader: false });
          if (checkApiStatus(response)) {
            if (this.state.attachedDoc?.length) {
              addAttachmentApi(response?.data, this.props, this.state.attachedDoc, "22", this.toggleFnc);
              this.setState({ modal: false, mode: '', eoa: {}, error: {} });
            } else {
              this.props.getResponseBack();
              this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
              this.setState({ modal: false, mode: '', eoa: {}, error: {} });
            }

          } else {
            this.props.enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
          }
        })
      }else{
        this.setState({error: validationInputs});
      }
    }
  previewDoc(item) {
    this.setState({ previewDocs: item })
  }
  handleDelete = (item) => {
    this.setState({ deleteAttachmentModal: true, deleteItem: item });
  };

  deleteAttachment = (item) => {
    const { eoa, deleteItem } = this.state;
    this.setState({ deleteAttachmentModal: false, pageLoader: true });
    globalDeleteService(`contracts/attachments/${deleteItem.uuid}/`)
      .then((response) => {
        this.setState({ pageLoader: false });
        if (response?.data?.statusCode === 200) {
          const updatedAttachment = eoa.attachments.filter((file) => file.uuid !== deleteItem.uuid);
          this.setState({ eoa: { ...eoa, attachments: updatedAttachment } });
          this.getEoaApi(this.props, eoa.id)
          toastFlashMessage(response?.data?.message, 'success');
        } else {
          toastFlashMessage(response?.data?.message, 'error');
        }
      })
  };


  getDeleteResponse = () => {
    const { eoa, deleteItem } = this.state
    const updatedAttachments = eoa?.attachments?.filter(
      attachment => attachment.uuid !== deleteItem?.uuid
    );
    this.setState(prevState => ({
      ...prevState,
      eoa: {
        ...prevState.eoa,
        attachments: updatedAttachments
      }
    }))
    this.props.getResponseBack()
  }

  toggleRemarks = () => {
    this.setState((prevState) => ({ showFullRemarks: !prevState.showFullRemarks }));
  };

  render() {
    const { modal, formSubmitLoader, mode, eoa, error, pageLoader, previewDocs, deleteAttachmentModal, showFullRemarks } = this.state;
    const { id, m, contractInfo } = this.props;
    return (
      <Fragment>
        {pageLoader ? <PageLoader /> : null}
        {id ?
          <span onClick={() => this.getEoaApi(this.props, id, m)}><Tooltip title="View"><VisibilityIcon color='primary' fontSize='small' style={{ cursor: 'pointer' }} /></Tooltip></span> :
          (contractInfo?.hdlineInfo?.archived_asset == false ?
            <Button onClick={() => this.setState({ modal: true, eoa: addEoa, mode: 'add' })} variant="contained" color="primary"><AddIcon style={{fontSize: '1.15rem'}} />Add Exceptions to Acceptance</Button>
            : null)
        }
        {modal ?
          <Drawer
            open={modal}
            anchor="right"
            onClose={() => this.setState({ modal: false, mode: '', eoa: {}, error: {} })}
          >
            <div style={{ width: '670px' }} className="drawer-container">
              <div className="drawer-header" alignItems='center'>
                <span className="left-blk">{`${capitalizeFirstLetter(mode)} Exceptions to Acceptance`}</span>
                <CloseIcon className="close-icon" onClick={() => this.setState({ modal: false })} />
                {mode !== 'add' ?
                  <ul className="list-inline right-blk">
                    <li className="list-inline-item">
                      <RevisionHistory
                        url='audit/contracts/ctexceptiontoacceptance/'
                        queryParams={{ action: 1, object_id: id }}
                        buttonType={false}
                      />
                    </li>
                    <li className="list-inline-item">
                      {contractInfo?.hdlineInfo?.archived_asset == false ? checkPermission('contracts','exceptions_to_acceptance', 'U') && mode === 'view' && <span className="cta" onClick={() => this.setState({ mode: 'edit' })}><EditIcon className="edit-icon" />Edit</span> : false}
                      {mode !== 'view' && <span className="cta" onClick={() => this.setState({ mode: 'view' })}><VisibilityIcon className="view-icon" />View</span>}
                    </li>
                  </ul> : null
                }
              </div>
              <div className="drawer-body" style={{ position: "sticky" }}>
                <Grid container spacing={3}>
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Name" value={eoa?.name ? eoa.name : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          required
                          id="name"
                          label="Name"
                          fullWidth
                          margin="normal"
                          value={eoa?.name || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'name', e.target.value)}
                          error={error.name ? true:false }
                          helperText={error.name ? error.name: ''}
                          onFocus={(e) => this.updateErrorField('name', '')}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Description" value={eoa?.description ? <span dangerouslySetInnerHTML={{ __html: eoa?.description.replace(/\n/g, '<br />') }} /> : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="description"
                          label="Description"
                          fullWidth
                          multiline
                          rows={4}
                          margin="normal"
                          value={eoa?.description || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'description', e.target.value)}
                        />
                      </Grid>
                  }
                  {avationPlcInstance||leshaBankInstance||mtInstance?<>
                  {mode === 'view' ?
                    <LabelValueCard md={12} label="Component" value={eoa?.extra_fields?.eta_component ? eoa?.extra_fields?.eta_component : '--'} /> :
                    <Grid item xs={12} md={6}>
                      <TextField
                        id="eta_component"
                        label="Component"
                        fullWidth
                        margin="normal"
                        value={eoa?.extra_fields?.eta_component || ''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => this.onFieldChange(e, 'eta_component', e.target.value.trimStart())}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={12} label="Reference" value={eoa?.extra_fields?.eta_reference ? eoa?.extra_fields?.eta_reference : '--'} /> :
                    <Grid item xs={12} md={6}>
                      <TextField
                        id="eta_reference"
                        label="Reference"
                        fullWidth
                        margin="normal"
                        value={eoa?.extra_fields?.eta_reference || ''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => this.onFieldChange(e, 'eta_reference', e.target.value.trimStart())}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={12} label="Amount" value={eoa?.extra_fields?.eta_amount ? eoa?.extra_fields?.eta_amount : '--'} /> :
                    <Grid item xs={12} md={6}>
                      <TextField
                        id="eta_amount"
                        label="Amount"
                        fullWidth
                        margin="normal"
                        value={eoa?.extra_fields?.eta_amount || ''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ? this.onFieldChange(e, 'eta_amount', e.target.value) : e.preventDefault()}
                      />
                    </Grid>
                  }
                  {mode == 'view' ?
                    <LabelValueCard md={12} label='Date' value={eoa?.extra_fields?.eta_date ? moment(eoa?.extra_fields?.eta_date).format(displayDateFormatShort) : '--'} /> :
                    <Grid item xs={12} md={6}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          margin="normal"
                          id="eta_date"
                          label="Date"
                          format={fieldDateFormat}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          clearable={true}
                          error={error.eta_date}
                          helperText={error.eta_date}
                          onFocus={()=>this.updateErrorField('eta_date', '')}
                          value={eoa?.extra_fields?.eta_date ? eoa?.extra_fields?.eta_date : null}
                          onChange={(data, value) => { this.onFieldChange(value, 'eta_date', data ? moment(data).format(backendDateFormat) : data) ;this.updateErrorField('eta_date', '')}}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  }
                  {mode == 'view' ?
                    <LabelValueCard md={12} label='Completion Date' value={eoa?.extra_fields?.eta_completion_date ? moment(eoa?.extra_fields?.eta_completion_date).format(displayDateFormatShort) : '--'} /> :
                    <Grid item xs={12} md={6}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          margin="normal"
                          id="eta_completion_date"
                          label="Completion Date"
                          format={fieldDateFormat}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          clearable
                          error={error.eta_completion_date}
                          helperText={error.eta_completion_date}
                          onFocus={()=>this.updateErrorField('eta_completion_date', '')}
                          value={eoa?.extra_fields?.eta_completion_date ? eoa?.extra_fields?.eta_completion_date :null}
                          onChange={(data, value) => { this.onFieldChange(value, 'eta_completion_date', data ? moment(data).format(backendDateFormat) : data) ;this.updateErrorField('eta_completion_date', '')}}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={12} label="Status" value={eoa?.extra_fields?.eta_status ? eoa?.extra_fields.eta_status : '--'} /> :
                    <Grid item xs={12} md={6}>
                      <TextField
                        id="eta_status"
                        label="Status"
                        fullWidth
                        margin="normal"
                        value={eoa?.extra_fields?.eta_status || ''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => this.onFieldChange(e, 'eta_status', e.target.value.trimStart())}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={12} label="Significant" value={eoa?.extra_fields?.eta_significant ? eoa?.extra_fields.eta_significant : '--'} /> :
                    <Grid item xs={12} md={6}>
                      <TextField
                        id="eta_significant"
                        label="Significant"
                        fullWidth
                        margin="normal"
                        value={eoa?.extra_fields?.eta_significant || ''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => this.onFieldChange(e, 'eta_significant', e.target.value.trimStart())}
                      />
                    </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Remarks" value={eoa?.extra_fields?.eta_remarks && eoa?.extra_fields.eta_remarks.length > 200 ? (
                        <div>
                          {showFullRemarks ? (
                            <span>
                              <span dangerouslySetInnerHTML={{ __html: eoa?.extra_fields?.eta_remarks && eoa?.extra_fields?.eta_remarks?.replace(/\n/g, '<br />') }} />
                              <a href="#" style={{ color: '#0E7FE1', fontSize: '14px', marginLeft: 5 }} onClick={(e) => { e.preventDefault(); this.toggleRemarks(); }}>
                                less
                              </a>
                            </span>
                          ) : (
                            <span>
                              <span dangerouslySetInnerHTML={{ __html: eoa?.extra_fields?.eta_remarks.substring(0, 190).replace(/\n/g, '<br />') }} />
                              <a href="#" style={{ color: '#0E7FE1', fontSize: '14px', marginLeft: 5 }} onClick={(e) => { e.preventDefault(); this.toggleRemarks(); }}>
                                ..more
                              </a>
                            </span>
                          )}
                        </div>
                      ) : (
                        <div>{eoa?.extra_fields?.eta_remarks !== '--' ? <span dangerouslySetInnerHTML={{ __html: eoa?.extra_fields?.eta_remarks && eoa?.extra_fields?.eta_remarks.replace(/\n/g, '<br />') }} /> : '--'}</div>
                      )} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="eta_remarks"
                          label="Remarks"
                          fullWidth
                          multiline
                          rows={3}
                          margin="normal"
                          value={eoa?.extra_fields?.eta_remarks || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'eta_remarks', e.target.value)}
                        />
                      </Grid>
                    }</> : null}
                  {mode === 'view' ?
                    <div style={{ marginLeft: '8px', marginBottom: '20px' }}>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular" }}>Attachment(s) {eoa?.attachments?.length > 0 ? `[Count : ${eoa?.attachments?.length}]` : null}</p>
                      {eoa?.attachments?.length ? eoa?.attachments && eoa?.attachments.map((file, index) => (
                        <CustomChip
                          style={{ marginRight: '4px', marginTop: '7px' }}
                          title={file.name}
                          index={index}
                          label={file.name.substring(0, 14) + '...'}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file }) }}
                        />
                      )) : '--'}
                    </div>
                    :
                    (
                      <Grid item xs={12} style={{ marginBottom: '20px' }} className='drag-drop'>
                        <p style={{ fontSize: '13px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular", marginLeft: '8px' }}>Attachment(s)</p>
                        <CustomDropzone
                          onChange={(files) => this.setState({ attachedDoc: files })}
                          componentData={eoa}
                          attachedDoc={this.state.attachedDoc}
                        >
                        </CustomDropzone>
                        {eoa?.attachments && eoa?.attachments.map((file, index) => (
                          <CustomChip
                            style={{ marginRight: '4px', marginTop: '7px' }}
                            title={file.name}
                            index={index}
                            label={file.name.substring(0, 14) + '...'}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file }) }}
                            onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteAttachmentModal: true, deleteItem: file }); }}
                          />
                        ))}
                      </Grid>)}
                </Grid>
              </div>
              <div className="drawer-footer">
                {mode !== 'view' ?
                  <Button onClick={this.addEditEtaFn} color="primary" variant="contained" disabled={formSubmitLoader}>
                    {formSubmitLoader ? <CircularProgress color="#ffffff" size={24} /> : 'Save Changes'}
                  </Button> : null
                }
                <Button onClick={() => this.setState({ modal: false, mode: '', eoa: {}, error: {} })} color="primary" style={mode == 'view' ? { marginLeft: 'auto', paddingLeft: '0px' } : { marginLeft: '8px' }}>Cancel</Button>
              </div>
            </div>
          </Drawer> : null
        }
        {
          this.state.previewDocs ? <PreviewDocsModal previewDocs={this.state.previewDocs} toggleModalFn={() => this.setState({ previewDocs: '' })} /> : null
        }
        {this.state.deleteAttachmentModal ?
          <DeletePopUp
            modal={this.state.deleteAttachmentModal}
            toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
            title="Delete Attachment"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => deleteAttachmentApi(this.state.deleteItem, this.toggleFnc, this.getDeleteResponse)}
          /> : null
        }
      </Fragment>
    )
  }
}
export default withRouter(withSnackbar(ExceptionAcceptenceCRU));
